import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./layout/header/header.component";
import { PageLoaderComponent } from "./layout/page-loader/page-loader.component";
import { SidebarComponent } from "./layout/sidebar/sidebar.component";
import { RightSidebarComponent } from "./layout/right-sidebar/right-sidebar.component";
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { DynamicScriptLoaderService } from "./shared/services/dynamic-script-loader.service";
import { ConfigService } from "./shared/services/config.service";
import { RightSidebarService } from "./shared/services/rightsidebar.service";
import { AuthGuard } from "./shared/security/auth.guard";
import { NgxSpinnerModule } from "ngx-spinner";
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { NgxMaskModule } from "ngx-mask";
import { MatListModule } from "@angular/material/list";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ClickOutsideModule } from "ng-click-outside";
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CustomGuard } from './_helpers/custom.guard';
import { CookieService } from 'ngx-cookie-service';
import { UserIdleModule } from 'angular-user-idle';
import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";
import { ErrorHandler } from '@angular/core';
import { Injectable } from '@angular/core';
import { LandingLayoutComponent } from './layout/app-layout/landing-layout/landing-layout.component';
import { LandingHeaderComponent } from './layout/landing-header/landing-header.component';
import { LandingFooterComponent } from './layout/landing-footer/landing-footer.component';
import { LoaderInterceptor } from './_helpers/loader.interceptor';
import { SharedModule } from "./shared/shared.module";
import {CustomFormsModule} from "ngx-custom-validators";
import {GuestLayoutComponent} from "./layout/app-layout/guest-layout/guest-layout.component";
import {GuestGuard} from "./_helpers/guest.guard";

// Sentry.init({
//   dsn: "https://9b2edff3ba2749a19ac6ab07fd2e6ccd@o476772.ingest.sentry.io/5516873",
//   integrations: [
//     new Integrations.BrowserTracing({
//       tracingOrigins: ["localhost:4200", "http://192.168.0.176:7778"],
//       routingInstrumentation: Sentry.routingInstrumentation,
//     }),
//   ],

//   // We recommend adjusting this value in production, or using tracesSampler
//   // for finer control
//   tracesSampleRate: 1.0,
// });

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error) {
    throw error;
    //console.log(error);
    //Sentry.captureException(error.originalError || error);
  }
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false,
};
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LandingHeaderComponent,
    LandingFooterComponent,
    PageLoaderComponent,
    SidebarComponent,
    RightSidebarComponent,
    AuthLayoutComponent,
    MainLayoutComponent,
    LandingLayoutComponent,
    GuestLayoutComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    MatIconModule,
    MatButtonModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatButtonToggleModule,
    NgxSpinnerModule,
    ClickOutsideModule,
    NgxMaskModule.forRoot(),
    MatSnackBarModule,
    SharedModule,
    UserIdleModule.forRoot({ idle: 1790, timeout: 1, ping: 0 }),
    CustomFormsModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler
    },
    DynamicScriptLoaderService,
    ConfigService,
    RightSidebarService,
    AuthGuard,
    CustomGuard,
    GuestGuard,
    CookieService
  ],
  entryComponents: [
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
